import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  ILddUserDataResponse,
  IUserAgencies,
  IUserDetailResponse,
  IUserManagementResponse,
  LDD_ORGModel,
  SubmitEditUserData,
  SubmitEditUserDataRes,
  UserApiResponse,
  UserManagementRes,
} from '../../../models/interface/users/users';
import { IToggleActionData } from '../../../models/interface/materials/i-action-data';
import { ApiResponse } from '../../../models/interface/api-response/api-response';
import { OrgItemCheck } from '../../../models/interface/login/i-login';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(private http: HttpClient) { }

  private lddUserUrlBase = environment.url.lddApiUrl;

  getAllMUserList(searchInfo: IUserAgencies): Observable<IUserManagementResponse> {
    const getAllUserListUrl = `${this.lddUserUrlBase}${environment.url.userManagement.getAllListUrl}`;

    let body = searchInfo;

    return this.http.post<IUserManagementResponse>(getAllUserListUrl, body);
  }

  toggleActiveSwitch(updateTw: IToggleActionData): Observable<ApiResponse> {
    const activeToggleFlagUrl = `${this.lddUserUrlBase}${environment.url.userManagement.editUsertActiveFlagByID}`;
    let body = {
      user_id: updateTw.selectedId,
      is_active: updateTw.enableToggle,
    };
    return this.http.patch<ApiResponse>(activeToggleFlagUrl, body);
  }

  getLDDUserDataByIdCard(idCard: string): Observable<ILddUserDataResponse> {
    const getUserByCitizenIdUrl = `${this.lddUserUrlBase}${environment.url.user.getUserByCitizenId}`;
    let body = {
      citizen_id: idCard,
    };
    return this.http.post<ILddUserDataResponse>(getUserByCitizenIdUrl, body);
  }

  deleteUserID(userId: number): Observable<ApiResponse> {
    const deleteUserManagementByIDUrl = `${this.lddUserUrlBase}${environment.url.userManagement.deleteUserManagementByID}`;
    let body = {
      user_id: userId,
    };
    return this.http.patch<ApiResponse>(deleteUserManagementByIDUrl, body);
  }

  getUserDetail(userId: number): Observable<UserManagementRes> {
    const getUserDetail = `${this.lddUserUrlBase}${environment.url.userManagement.getUserManagementByIDUrl}`;
    let body = {
      user_id: userId
    }
    return this.http.post<UserManagementRes>(getUserDetail, body);
  }

  getAllUserDetailsList(user_id: number): Observable<IUserDetailResponse> {
    const getUserDeail = `${this.lddUserUrlBase}${environment.url.userManagement.getUserManagementByIDUrl}`;
    let body = {
      user_id: user_id
    }
    return this.http.post<IUserDetailResponse>(getUserDeail, body);
  }

  onSubmitEdit(formData: SubmitEditUserData): Observable<SubmitEditUserDataRes> {
    const submitData = `${this.lddUserUrlBase}${environment.url.userManagement.editUserManagementByID}`;
    let body = formData;
    return this.http.patch<SubmitEditUserDataRes>(submitData, body);
  }

  createUser(body: any): Observable<any> {
    const getUserDeail = `${this.lddUserUrlBase}${environment.url.userManagement.createUserManagementRight}`;
    return this.http.post<any>(getUserDeail, body);
  }

  getMasterAgencyAndSubAgency(org_id: number): Observable<any> {
    let body = {
      org_id: org_id
    }
    const getUserDeail = `${this.lddUserUrlBase}${environment.url.userManagement.getMasterAgencyAndSubAgency}`;
    return this.http.post<any>(getUserDeail, body);
  }

  getORGHeadItem(body: LDD_ORGModel): Observable<UserApiResponse<OrgItemCheck>> {
    const getUserDeail = `${this.lddUserUrlBase}${environment.url.userManagement.getORGHeadItem}`;
    return this.http.post<UserApiResponse<OrgItemCheck>>(getUserDeail, body);
  }

  getSignatureBase64(url_path: string): Observable<any> {
    const getUserDeail = `${this.lddUserUrlBase}${environment.url.userManagement.getSignature}`;
    return this.http.post<any>(getUserDeail, {
      signature: url_path
    });
  }

  toggleSecondaryRoleStatus(data: any): Observable<ApiResponse> {
    const toggleSecondaryRoleStatus = `${this.lddUserUrlBase}${environment.url.userManagement.toggleSecondaryRoleStatus}`;
    return this.http.post<ApiResponse>(toggleSecondaryRoleStatus, data);
  }
}
